import { SvgIcon, SvgIconProps } from "@mui/material";

export const TicketLogIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M17.5 10a7.5 7.5 0 1 0-7.5 7.5M16.667 13.333h-3.334"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M10.417 6.667v4.055L7.5 12.5M16.667 15.833h-3.334"
      />
    </svg>
  </SvgIcon>
);
